import { handleActions } from 'redux-actions';

import * as types from './actionTypes';

const initialState = {};

const saveData = (state, action) => {
	const { contactDetailData } = action.payload;

	return {
		...state,
		...contactDetailData,
	};
};

const addNote = (state, action) => {
	const { comment, firstname, surname } = action.payload;

	return {
		...state,
		comments: [
			...state.comments,
			{
				comment,
				dateCreated: new Date().toISOString(),
				userCreatedFirstName: firstname,
				userCreatedSurname: surname,
			},
		],
	};
};

const appendAdditionalDataToContact = (state, action) => {
	const { additionalData } = action.payload;

	return {
		...state,
		additionalData,
	};
};

const setCameToDetailFrom = (state, action) => {
	const { cameToDetailFrom } = action.payload;

	return {
		...state,
		cameToDetailFrom,
	};
};

const resetDetail = () => initialState;

const contactDetailReducer = {
	[types.SAVE_DATA]: saveData,
	[types.ADD_NOTE]: addNote,
	[types.SET_CAME_TO_DETAIL_FROM]: setCameToDetailFrom,
	[types.APPEND_ADDITONAL_DATA_TO_CONTACT]: appendAdditionalDataToContact,
	[types.RESET_DETAIL]: resetDetail,
};

export default handleActions(contactDetailReducer, initialState);
